import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import { AppState } from "../../RootReducer";
import { useDispatch, useSelector } from "react-redux";
import BetbyClientService, { BetbyParamters, handleConfig } from "./BetbyClient";
import { getContainer } from "../../ioc/IOCSetup";
import { LaunchBetbyResponse } from "../../http/protocol";
import { useHistory, useLocation } from "react-router";
import { PATH } from "../../onboardingpage/modalview/UserModalController";
import { usePrevious } from "../../user/ui/utils";
import { progressBar } from "../../utils/ProgressBar";
import { showCashier } from "../../payments/DepositActions";
import { CashierSection } from "../../payments/PaymentsReducer";
import loggedin from "../../layout/Loggedin";

export enum BRrenderStatus {
     fail,
     success,
     pending,
}

interface BetbyAppProps {
     lng?: string;
     currency?: string;
     config?: BetbyParamters;
}

function BetbyApp(props: BetbyAppProps) {
     const history = useHistory();
     const location = useLocation();
     const dispatch = useDispatch();
     const betbyRef = useRef<BetbyClientService | undefined>(undefined);
     const [status, setStatus] = useState<BRrenderStatus>(BRrenderStatus.pending);
     const load = useRef<number>(0);
     let prevToken = usePrevious(props.config?.config.token);
     let prevSearchParam = usePrevious(location.search);

     const onTokenExpiredCallback = async (): Promise<any> => {
          return (
               (await getContainer().getSportsbookService().getBetbyGameLaunchUrl(props.lng ? props.lng : "EN", props.currency ? props.currency : "EUR")).token ?? null
          );
     };


     const pushSearchParamCallback = (path: string) => {
          history.push({ search: new URLSearchParams({ "bt-path": path }).toString() });
     };

     const onLoginCallback = () => {
          history.push({ search: new URLSearchParams({ type: PATH.LOGIN, modal: PATH.MODAL_TYPE }).toString() });
     };

     const onRegisterCallback = () => {
          history.push({ search: new URLSearchParams({ type: PATH.REGISTRATION, modal: PATH.MODAL_TYPE }).toString() });
     };

     const onRechargeCallback = () => {
          dispatch(showCashier(true, CashierSection.DEPOSIT))
     }

     const handlePathChange = () => {
          const btPath = new URLSearchParams(location.search).get("bt-path");
          return btPath ? decodeURIComponent(btPath) : null;
     };


     useEffect(()=>{
          if(location.pathname.includes("sportsbook") && !location.search && prevSearchParam){
              let prevRoute = localStorage.getItem("previousPath");
               let path = "/";
               if(prevRoute !== null && prevRoute !== "undefined"){
                    path = prevRoute
               }
               history.push(path); 
          }
     },[location.search])

     useEffect(()=>{
          if(location.pathname.includes("sportsbook") && !location.search){
               history.push({ search: new URLSearchParams({ "bt-path": encodeURI("/") }).toString() });
          }
     },[location.pathname]) 


     useEffect(() => {
          if (props.config) {
               if (betbyRef.current != undefined) {
                    if (handlePathChange() !== null) {
                         betbyRef.current?.updateOptions(handlePathChange() as string);
                    }
               }
          }
     }, [location.search]);

     useEffect(() => {
          if (props.config) {
               if (betbyRef.current != undefined) {
                    if (load.current !== 0) {
                         try {
                              if (prevToken != props.config.config.token) {
                                   betbyRef.current?.updateClient(props.config);
                                   setStatus(BRrenderStatus.success);
                              }
                         } catch (error) {
                              setStatus(BRrenderStatus.fail);
                         }
                    }
               }
          }
     }, [props.config, props.currency]);

     useEffect(() => {
          if (props.config) {
               if (betbyRef.current == undefined) {
                    if (load.current !== 1) {
                         load.current = 1;
                         try {
                              betbyRef.current = new BetbyClientService(props.config, onTokenExpiredCallback, onLoginCallback, pushSearchParamCallback, onRegisterCallback, onRechargeCallback);
                              setStatus(BRrenderStatus.success);
                         } catch (error) {
                              setStatus(BRrenderStatus.fail);
                         }
                    }
               }
          }
     }, []);

     useEffect(() => {
          return () => {
               if (betbyRef.current !== undefined) {
                    betbyRef.current.unsubscribe();
               }
          };
     }, []);
     

     if (status == BRrenderStatus.fail) {
          return (
               <div className="betby-error">
                    <span className="betby-error-message">Failed to initialize sportsbook</span>
               </div>
          );
     }

     return <div id="betby"></div>;
}

/* -------------------------------------------------- */
/* -------------------------------------------------- */


export default React.memo(function BetbySportsComponent() {
     const [config, setConfig] = useState<BetbyParamters | undefined>(undefined);
     const isLoggedin = useSelector((app: AppState) => app.user.user?.loggedIn,(prev, curr) => prev === curr);
     const currency = useSelector((app: AppState) => app.user.activeCurrency);
     const locale = getContainer().getSettingsService().getActiveLocale();
     const userLoaded = useSelector((app: AppState) => app.user.userInfoLoaded);
     //const isEffectExecuted = useRef(false);
     const currencyChanged = useRef(false);
     //let prevCurrency = usePrevious(currency);


     async function launchSportsBook(lng: string, currency: string): Promise<LaunchBetbyResponse> {
          let config: LaunchBetbyResponse;
          if (isLoggedin) {
               config = await getContainer().getSportsbookService().getBetbyGameLaunchUrl(lng, currency);
          } else {
               config = await getContainer().getSportsbookService().getBetbyAnonymousGameLaunchUrl();
          }
          return config;
     }

     useEffect(() => {

          if(locale.code && userLoaded) {
               if(currency && isLoggedin) {
                    launchSportsBook(locale.code, currency)
                        .then((c) => {
                             setConfig(handleConfig(c, locale.code));
                        })
                        .catch((e) => {
                             console.error(e);
                        });
               } else if(!isLoggedin) {
                    launchSportsBook(locale.code, currency ? currency : "EUR")
                        .then((c) => {
                             setConfig(handleConfig(c, locale.code));
                        })
                        .catch((e) => {
                             console.error(e);
                        });
               }
          }
     }, [locale.code, currency, userLoaded, isLoggedin]);

     /*
     useEffect(() => {
          if (isEffectExecuted.current === true && currencyChanged.current === false) {
               currencyChanged.current = true;
          }
     }, [currency, isLoggedin, prevCurrency]);
     */

     return <div className="betby-wrap">{config !== undefined ? <BetbyApp config={config} currency={currency} lng={locale.code} /> : <></>}</div>;
});


